var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentPersonFeedback24Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9245 31C37.2995 31.175 37.7245 31.25 38.1245 31.25C38.9495 31.25 39.7245 30.925 40.3245 30.35L45.7745 25H48.1245C51.9245 25 54.9995 21.925 54.9995 18.125V11.875C54.9995 8.075 51.9245 5 48.1245 5H36.8745C33.0745 5 29.9995 8.075 29.9995 11.875V18.125C29.9995 21.275 32.1245 23.925 34.9995 24.75V28.125C34.9995 29.375 35.7745 30.5 36.9245 31ZM19.9995 33.75C15.1745 33.75 11.2495 29.825 11.2495 25C11.2495 20.175 15.1745 16.25 19.9995 16.25C24.8245 16.25 28.7495 20.175 28.7495 25C28.7495 29.825 24.8245 33.75 19.9995 33.75ZM19.9995 55C14.8495 55 10.8995 53.6 8.24953 50.825C4.90953 47.315 4.99203 42.89 4.99953 42.4325V42.4C4.99953 39.725 7.24953 37.5 9.99953 37.5H29.9995C32.7495 37.5 34.9995 39.75 34.9995 42.5L35.002 42.515C35.0095 42.8325 35.1145 47.29 31.752 50.825C29.0995 53.6 25.1495 55 19.9995 55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentPersonFeedback24Filled);
export default __webpack_public_path__ + "static/media/fluent_person-feedback-24-filled.ceff2385dd063bb16fcc5c9b1c8f6238.svg";
export { ForwardRef as ReactComponent };